import { IRevenuePerformanceData } from '@/ducks/performance/performance.schema'
import { FormatPriceOptions } from '@/utils/currency.utils'

export const REVENUE_PAYOUT_PRICE_OPTIONS: FormatPriceOptions = {
  signDisplay: 'never',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
}

export const REVENUE_LEGACY_PRICE_OPTIONS: FormatPriceOptions = {
  signDisplay: 'never',
  maximumFractionDigits: 0,
  minimumFractionDigits: 0
}

export const parseRevenueAmount = (value?: string): number => {
  const parsed = parseFloat(value ?? '')
  return Number.isFinite(parsed) ? parsed : 0
}

export const hasPayoutFields = (data: IRevenuePerformanceData): boolean =>
  data?.returned_earnings !== undefined && data?.returned_earnings !== null

export const hasReturnedEarningsBreakdown = (
  data: IRevenuePerformanceData
): boolean =>
  hasPayoutFields(data) && parseRevenueAmount(data.returned_earnings) > 0

export const getTotalPayout = (data: IRevenuePerformanceData): number => {
  const netEarning = parseRevenueAmount(data.netEarning)

  if (!hasPayoutFields(data)) {
    return netEarning
  }

  return netEarning + parseRevenueAmount(data.returned_earnings)
}

export const hasTaxStampInfo = (data: IRevenuePerformanceData): boolean =>
  hasPayoutFields(data) &&
  parseRevenueAmount(data.tax_stamp_deductions) > 0

export const hasReimbursedCancelledInfo = (
  data: IRevenuePerformanceData
): boolean =>
  (data.reimbursed_cancelled?.count ?? 0) > 0

export const shouldShowInProgressNotice = (
  data: IRevenuePerformanceData
): boolean => data.in_progress_cycle === true
